import { DataService } from './dataService'

const ErrorMarginServices = {
	getErrorMargindata: async (data) => {
		return DataService.get('/admin/get_margin', data)
	},
	updateErrorMargindata: async (data) => {
		return DataService.post('/admin/update_margin', data)
	},
    addErrorMargindata: async (data) => {
		return DataService.post('/admin/add_margin', data)
	}
}

export default ErrorMarginServices